import { Box, Button, TextField } from "@mui/material";

/** Optional title field plus the hidden file input that triggers a PDF upload. */
const UploadControl = ({ uploadName, onNameChange, onUpload, uploading }) => (
  <Box sx={{ display: "flex", gap: 1, alignItems: "center", p: 1 }}>
    <TextField
      size="small"
      label="Title (optional)"
      value={uploadName}
      onChange={(event) => onNameChange(event.target.value)}
    />
    <Button component="label" variant="outlined" disabled={uploading}>
      Upload PDF
      <input
        hidden
        type="file"
        accept="application/pdf"
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file) onUpload(file);
          event.target.value = "";
        }}
      />
    </Button>
  </Box>
);

export default UploadControl;
